import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Urmăritori',
  steps: {
    upload: 'Încarcă',
    validate: 'Confirmă',
    finish: 'Finalizat',
  },
  labels: {
    import: 'Import',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
